import { render, staticRenderFns } from "./__arranged_purchase_detail.vue?vue&type=template&id=87bb2872&scoped=true&"
import script from "./__arranged_purchase_detail.vue?vue&type=script&lang=js&"
export * from "./__arranged_purchase_detail.vue?vue&type=script&lang=js&"
import style0 from "./__arranged_purchase_detail.vue?vue&type=style&index=0&id=87bb2872&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bb2872",
  null
  
)

export default component.exports